var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15.06 2.94a1.5 1.5 0 00-2.12 2.12l5.439 5.44H2.5a1.5 1.5 0 000 3h15.879l-5.44 5.44a1.5 1.5 0 002.122 2.12l8-8a1.5 1.5 0 000-2.12l-8-8z"}));
}

ArrowRight.defaultProps = {"viewBox":"0 0 24 24","fill":"currentColor"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
